/**
 * Куски .env для клиентского сайта (пожелание Давида, шаг 6.1): режим
 * запуска выбирает файл, SDK читает одни и те же переменные в любом режиме.
 *
 * - `npm run dev` — Development с черновиками;
 * - `npm run dev:preprod` — Production с ключом предпросмотра (препрод);
 * - `npm run dev:prod` и боевая сборка — Production, только опубликованное.
 *
 * FACETA_KEY — для сервера сайта, FACETA_PUBLIC_KEY — можно отдать в браузер.
 */
export interface EnvFile {
  name: string;
  mode: string;
  text: string;
}

export function envFiles(
  kind: 'production' | 'development',
  apiURL: string,
  publicKey: string,
  previewKey: string,
): EnvFile[] {
  const file = (name: string, mode: string, serverKey: string): EnvFile => ({
    name,
    mode,
    text: [
      `FACETA_API_URL=${apiURL}`,
      `FACETA_KEY=${serverKey}`,
      `FACETA_PUBLIC_KEY=${publicKey}`,
      '',
    ].join('\n'),
  });

  if (kind === 'development') {
    return [file('.env.development', 'npm run dev', previewKey)];
  }

  return [
    file('.env.preprod', 'npm run dev:preprod, препрод — с черновиками', previewKey),
    file('.env.production', 'npm run dev:prod и боевая сборка', publicKey),
  ];
}
